import { Copy, Sparkles } from "lucide-react";
import { useEffect, useState } from "react";
import { API_URL } from "../config";

const PromptAi = ({ prompt, displayPrompt = true }) => {
    const [promptResult, setPromptResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isCopied, setIsCopied] = useState(false);

    const getAISuggestion = async (prompt) => {
        setLoading(true);
        setPromptResult(null);
        try {
            const response = await fetch(`${API_URL}?action=getAISuggestion`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ prompt })
            });
            const res = await response.json();
            setPromptResult(res);
        } catch (error) {
            console.error("Erreur lors de la récupération de la suggestion IA:", error);
            setPromptResult({ suggestion: "Une erreur est survenue. Veuillez réessayer." });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (prompt) {
            getAISuggestion(prompt);
        }
    }, [prompt]);

    const handleCopyToClipboard = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text).then(() => {
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        });
    };

    return (
        <div className="space-y-3">
            {displayPrompt && <p className="text-xs text-gray-500 font-mono bg-gray-50 p-2 rounded-md">{prompt}</p>}

            {loading && (
                <div className="flex items-center space-x-2 text-sm text-gray-500">
                    <Sparkles className="h-4 w-4 animate-pulse" />
                    <span>Génération du post en cours...</span>
                </div>
            )}

            {promptResult?.suggestion && (
                <div className="flex items-start justify-between space-x-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="flex-grow text-sm text-gray-800 whitespace-pre-wrap">{promptResult.suggestion}</p>
                    <button
                        onClick={() => handleCopyToClipboard(promptResult.suggestion)}
                        className={`flex-shrink-0 px-3 py-1 text-sm text-white rounded-md flex items-center transition-colors ${isCopied ? 'bg-green-500' : 'bg-blue-600 hover:bg-blue-700'}`}
                    >
                        <Copy className="h-4 w-4 mr-2" />
                        {isCopied ? 'Copié !' : 'Copier'}
                    </button>
                </div>
            )}
        </div>
    );
}

export default PromptAi;